import type { UserInfo } from "../types";
import { UserRole } from "../types";
import { UserRoleManager } from "./userRole";

const ROLE_LABEL: Record<UserRole, string> = {
  [UserRole.USER]: "普通用户",
  [UserRole.OPERATOR]: "操作者",
  [UserRole.ASSESSOR]: "审核者",
  [UserRole.ADMINISTRATOR]: "管理员",
};

/**
 * 与个人中心「角色」展示一致：基于 UserRoleManager 解析后的主角色，映射为中文。
 */
export const getRoleDisplayLabel = (userInfo: unknown): string => {
  if (!userInfo || typeof userInfo !== "object") {
    return "用户";
  }
  const u = userInfo as Partial<UserInfo> & { roles?: unknown[] };
  if (!u.username && !u.roles?.length) {
    return "用户";
  }
  try {
    const roleInfo = UserRoleManager.getUserRole(u as UserInfo);
    return ROLE_LABEL[roleInfo.role] || "用户";
  } catch {
    return "用户";
  }
};
